module.exports = __webpack_public_path__ + "img/icon01.01480d3a.png";